<template>
<div class="card">
    <div class="card-header">Reference Check</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
        <BaseStatusHelp lifecycleStatus="36"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="36" :requestId="request.id"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" lg="6">
                    <BaseSelector v-model="request.refCheckNeeded" 
                        :v="$v.request.refCheckNeeded"
                        label="Reference Check Needed"
                        slug="needed"
                        :options=neededOptions />
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="request.refCheckComments"
                        :v="$v.request.refCheckComments" 
                        slug="comments"
                        label="Reference Check Comments"/>
                </b-col>
            </b-row>
            
            <div>
            <b-button type="submit" variant="primary">Complete</b-button>
            <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
            </div>
        </b-form>
    </div>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric, requiredUnless } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'
import _ from "lodash"
import {commonOptions} from "@/mixins/commonOptions";

export default {
    components: {
        LifecycleCheckList,
    },
    props: {
        request: Object
    },
  mixins: [
    commonOptions
  ],
  data() {
        return {
            checklistComplete: false,
            saveOnly: false,
            neededOptions: [
              { value: true, text: 'Yes' },
              { value: false, text: 'No' },
            ],
        }
    },
    validations() {
        return {
         checklistComplete: { checked: value => value === true },
         request: {  
             refCheckComments: { required: false, maxLength: maxLength(4000)},  
             refCheckNeeded: { required: false }
        }
       } 
    },
    
    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },

        save() {
            this.saveOnly = true
            this.onSubmit()
            this.saveOnly = false
        },

        onSubmit() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                refCheckComments: this.request.refCheckComments, 
                refCheckNeeded: this.request.refCheckNeeded,
                advanceNextLifecycle: !this.saveOnly,
            }

            console.log(payload)

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/queue/refcheck`, payload)
                  .then(response => { 
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    if (payload.advanceNextLifecycle === true) {
                        this.$router.push('/home')
                    } 
                  })         
        },
        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
    }   
}
</script>